<template>
  <div id="productos-registra">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text"
                >Reporte que estás gestionando:
                {{ descripcionProducto }}</v-toolbar-title
              >
            </v-toolbar>
            <v-toolbar v-if="filename != null" card color="white">
              <v-toolbar-title class="indigo--text"
                >Archivo inicial enviado por proveedor:
                {{ filename }}</v-toolbar-title
              >
            </v-toolbar>
            <v-form>
              <v-container>
                <v-layout>
                  <v-flex>
                    <!-- INICIO DATOS DE REGISTRO REPORTE PADRE -->
                    <data-relator
                      :id="id"
                      :tipeView="tipeView"
                      :idReporte="idReporte"
                    ></data-relator>
                    <!-- TERMINO DATOS DE REGISTRO REPORTE -->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import DataRelator from "@/modules/impresion/views/reportes/ProductosData.vue";

import axios from "axios";

export default {
  name: "producto-registra",
  components: {
    DataRelator,
  },
  props: {},

  data: () => ({
    documentoId: "",
    tipeView: "",
  }),

  computed: {},
  mounted() {},
  created() {
    this.id = this.$route.params.id;
    this.code = this.$route.params.code;
    this.idReporte = this.$route.params.idReporte;
    this.tipeView = this.$route.params.tipeView;
    this.descripcionProducto = this.$route.params.descripcionProducto;
    this.filename = this.$route.params.filename;
  },

  methods: {
    volver() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "GridHistoricoImpresion",
          params: { id: this.id, code: this.code, tipeView: "consulta" },
        });
      }, 1000);
    },
  },
};
</script>
